import http from './httpService';

export function getSalesOffices() {
	return http.get('SalesOffice');
}

export function getSalesOfficesMy() {
	return http.get('SalesOffice/my');
}
